import { executiveActivities } from './dashboard.data';

export const ExecutiveRecentActivity = () => (
  <section
    className="arx-executive-panel"
    aria-labelledby="arx-dashboard-activity-title"
  >
    <div className="arx-executive-panel__header">
      <div>
        <span>GOVERNANÇA</span>
        <h2 id="arx-dashboard-activity-title">Atividades recentes</h2>
      </div>
    </div>

    <div className="arx-executive-activity-list">
      {executiveActivities.map(item => (
        <article className="arx-executive-activity" key={item.id}>
          <span className="arx-executive-activity__marker" aria-hidden="true" />
          <div>
            <strong>{item.title}</strong>
            <p>{item.description}</p>
          </div>
          <time>{item.timestamp}</time>
        </article>
      ))}
    </div>
  </section>
);
